import { createAction } from 'redux-actions';
import { route } from 'preact-router';
import * as tokenValidation from '../api/tokenValidation';
import { actionTypes } from './index';
import { TT_MAP } from '../api/tokenValidation';
// eslint-disable-next-line import/no-cycle
import { routes } from '../components/app';
import { LOCAL_STORAGE } from '../utils/consts';

const tokenValidateRequest = createAction(actionTypes.TOKEN_VALIDATE_REQUEST);
const tokenValidateFailure = createAction(actionTypes.TOKEN_VALIDATE_FAILURE);

export const tokenValidateReset = createAction(actionTypes.TOKEN_VALIDATE_RESET);

export function tokenValidateSuccess() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.TOKEN_VALIDATE_SUCCESS,
    });

    localStorage.setItem(LOCAL_STORAGE.ACTIVATION, 'true');

    route(routes.LOG_IN);
  };
}

/**
 *
 * @param {{ token: string }} payload
 */
export function tokenValidate(payload) {
  return async (dispatch) => {
    try {
      const { token } = payload;

      dispatch(tokenValidateRequest());

      const { activate } = await tokenValidation.token(token, TT_MAP.REGISTRATION);

      if (activate) {
        dispatch(tokenValidateSuccess());
      } else {
        // Add fallback logic if necessary
      }
    } catch (error) {
      dispatch(tokenValidateFailure(error));
    }
  };
}



// WEBPACK FOOTER //
// ./actions/tokenValidation.js